<template lang="pug">
.item
  .image.ui.placeholder(v-if="image")
    .image
  .content
    .header(v-if="title")
      .ui.placeholder
        .header
    .meta.right.ui.grid.mobile.hidden(v-if="meta")
      .column
        .ui.placeholder
          .line
          .line
      .column
        .ui.placeholder
          .line
          .line
</template>

<script lang="ts">
import Vue from "vue"
export default Vue.extend({
  name: "LoadingListItem",
  props: {
    image: { type: Boolean, default: true },
    title: { type: Boolean, default: true },
    meta: { type: Boolean, default: false },
    actions: { type: Boolean, default: false },
  },
})
</script>

<style scoped lang="sass">
.item
  .image.placeholder
    padding-top: 0
    .image
      height: 4rem !important
      width: 4rem
  .column
    .ui.placeholder
      width: 100%
</style>
